import styled from 'styled-components';

import { FlexDiv, GenericDiv } from '../../../../common/Styles';

export const FeatureWrapper = styled(GenericDiv)(
	({ theme: { down, breakpoints } }) => `
		position: relative;
		background: #fff;
		padding: 90px 0 50px;
		${down(breakpoints.md)} {
			padding: 10px 0 0;;
		}
  `
);

export const ImgWrap = styled(GenericDiv)(
	({ theme: { down, breakpoints } }) => `
		${down(breakpoints.md)} {
			position: absolute;
			top: 180px;
			left: 0;
		}
		img {
			box-shadow: -20px -20px #eeeeee;
		}
  `
);

export const TabsElem = styled(GenericDiv)(
	({ active, theme: { down, breakpoints } }) => `
		display: inline-block;
		text-align: center;
		padding: 10px 30px;
		font-size: 18px;
		position: relative;
		margin-right: 27px;
		cursor: pointer;
		&:last-of-type {
			margin-right: 0;
		}
		&:after {
			content: '';
			width: 100%;
			position: absolute;
			bottom: -3px;
			left:0;
			border-bottom: 2px solid #EEEEEE;
		}
		${down(breakpoints.tb)} {
			font-size:12px;
			margin-right: 10px;
			padding: 6px 18px;
		}
		${active && `
			font-weight: 700;
			&:after {
				border-bottom: 5px solid #F76162;
				border-radius: 18px;
			}`}
  `
);
